import { ResultProcess } from './models/resultProcess';
import { Component, OnInit } from '@angular/core';
import { LabMDM } from './models/lab';
import { CarrierState } from './models/carrierState';
import { Machine } from './models/machine';
import { BusinessArea } from './models/businessArea';
import { MasterDataService } from './masterdata.service';
import { ErrorHandler } from "../utils/error-handler"
import { MessagesService } from '../messages/messages.service';
import { MasterList } from './masterList-enum';
import { SeqConfig } from './models/seqConfig';
import { Chemical } from './models/chemical';
import { SelectableHazardousType } from './selectable-hazardoustype';
import { SelectableAssayType } from './models//SelectableAssayType';
import { AssayType } from './models/assayType-enum';
import { HazardousType } from './hazardousType-enum';
import { Printer } from './models/printer';
import { MachineType } from './models/machineType';
import { Product } from './models/product';
import { BmsProductName } from './models/BmsProductName';
import { SelectableProcessStep } from './models/SelectableProcessStep';
import { LibType } from './models/libType';
import { EchoConfig } from './models/echoConfig';
import { SalesItemTypeConfig } from './models/salesitemtype-config';
import { StandardPrimer } from './models/standardPrimer';
import { Template } from './models/template';
import { SenderDTO } from './models/sender-dto';
import { KitsDTO } from './models/kits-dto';
import { ProblemCategoryDTO } from './models/problemCategory';
import { ProblemDTO } from './models/problem';
import { LabEmitterService } from '../common-services/lab-emitter.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { ExternalSenderLoginDTO } from './models/externalSenderLogin';
import { Manufacturers } from './models/manufacturers';
import { RedoReason } from './models/redoReason';
import { InboundFileProcessing } from './models/inboundFileProcessing';
import { WorkFlow } from './models/workFlow';
import { WorkFlowNGS } from './models/workFlow';
import { Controls } from './models/controls';
import { TagSystem } from './models/tag-system';
import { Tags } from './models/tags';
import { FlowCell } from './models/flowcell';
import { Analysis } from './models/analysis';
import { ProcessFlow } from './models/processFlow';
import { SelectItem } from 'primeng/api/selectitem';
import { Project } from './models/project';

@Component({
	selector: 'app-masterdata',
	templateUrl: './masterdata.component.html',
	styleUrls: ['./masterdata.component.css']
})
//This component is used to display the various lisst of master data. This is the parent of the crud table component.
//The data regarding the feilds to disaply in the crud table is sent to the child component.
export class MasterdataComponent implements OnInit {

	countries: SelectItem[];
	statusCols: any[];
	labCols: any[];
	machineCols: any[];
	printerCols: any[];
	baCols: any[];
	seqConfigCols: any[];
	chemicalCols: Array<any>;
	machineTypesCols: any[];
	productCols: any[];
	accessLogsCols: any[];
	libTypeCols: any[];
	echoConfigCols: any[];
	sitConfigCols: any[];
	standardPrimerCols: any[];
	templateCols: any[];
	masenderCols: any[];
	kitCols: any[] = [];
	kitDetailCols: any[] = [];
	masenderDetailCols: any[] = [];
	labs: LabMDM[] = [];
	machines: Machine[] = [];
	printers: Printer[] = [];
	states: CarrierState[] = [];
	businessAreas: BusinessArea[] = [];
	seqConfigs: SeqConfig[] = [];
	chemical: Chemical[] = [];
	machineTypes: MachineType[];
	products: Product[] = [];
	libTypes: LibType[] = [];
	echoConfigs: EchoConfig[] = [];
	sitConfigs: SalesItemTypeConfig[] = [];
	standardPrimers: StandardPrimer[] = [];
	templates: Template[] = [];
	masenders: SenderDTO[] = [];
	kits: KitsDTO[] = [];
	problemCategories: ProblemCategoryDTO[] = [];
	problemCategoriesCols: any[];
	resultProcessCols: any[];
	resultEngineConfigCols: any[];
	problem: ProblemDTO[] = [];
	resultProcess: ResultProcess[] = [];
	problemCols: any[];
	labTitle: string = "Labs";
	machineTitle: string = "Machines";
	printerTitle: string = "Printers";
	processStepTitle: string = "Process Step";
	baTitle: string = "Business Areas";
	seqConfigTitle: string = "Sequencer Configurations";
	chemicalTitle: string = 'Chemical';
	machineTypesTitle: string = "Machine Types"
	productTitle: string = "Products"
	libTypeTitle: string = "LibTypes"
	echoConfigTitle: string = "Echo Configurations";
	sitConfigTitle: string = "Sales Item Types";
	standardPrimerTitle: string = "Standard Primers";
	templateTitle: string = "Barcode Templates";
	masenderTitle: string = "MA Senders";
	kitsTitle: string = "Kits Configuration"
	problemCategoryTitle: string = "Problem Category "
	problemTitle: string = "NC-Problem"
	resultProcessTitle: string = "Result-Process"
	resultEngineConfigTitle: string = "Result Logic"
	redoReasonTitle: string = "Redo Reason";
	inboundFileProcessingTitle: string = 'Inbound File Processing';
	workFlowTitle: string = 'Work Flow';
	workFlowNGSTitle: string = 'Work Flow NGS';
	salesItemTypesTitle = "Sales Item Types"
	labType = MasterList.LAB;
	machineType = MasterList.MACHINE;
	printerType = MasterList.PRINTER;
	baType = MasterList.BUSINESS_AREA;
	statusType = MasterList.CARRIER_STATUS;
	seqConfigType = MasterList.SEQUENCER_CONFIG;
	chemicalType = MasterList.CHEMICAL;
	machineTypeList = MasterList.MACHINE_TYPE;
	productType = MasterList.PRODUCT;
	libType = MasterList.LIB_TYPE;
	echoConfigType = MasterList.ECHO_CONFIGURATION;
	sitConfigType = MasterList.SALES_ITEM_TYPE;
	controlTitle: string = 'Controls';
	controlType = 'controls';

	labOptions: LabMDM[] = [];
	baOptions: BusinessArea[] = [];
	machineTypesOptions: MachineType[] = [];
	hazardousTypeOptions: SelectableHazardousType[] = [];
	assayTypeOptions: SelectableAssayType[] = [];
	errorHandler: ErrorHandler = new ErrorHandler;

	sitConfigOptions: SalesItemTypeConfig[] = [];
	bmsProductNames: BmsProductName[] = [];
	printerOptions: Printer[] = [];
	processStepOptions: SelectableProcessStep[];
	templateOptions: Template[] = [];

	loading: boolean;
	respose: any;
	health: any;
	healthCols: any[];
	accessLog: any;
	selectedLab: SelectableLab;

	maxRedoValues: SelectItem[];
	reactionOptionValues: SelectItem[];
	//Config for Machine Manufacturer Config
	manufacturerConfigTitle = "Machine Manufacturer";
	manufacturerConfigCols: any[];
	manufacturersList: Manufacturers[];

	externalSenderLogins: ExternalSenderLoginDTO[];
	externalSenderLoginTitle: string = "External Sender Login Templates";
	externalSenderLoginCols: any[];
	redoReasons: Array<RedoReason>;
	redoReasonCols: Array<any>
	inboundFileProcessing: Array<InboundFileProcessing>;
	inboundFileProcessingCols: Array<any>;
	workFlow: WorkFlow[];
	workFlowNGS: WorkFlowNGS[];
	workFlowCols: Array<any>;
	workFlowNGSCols: Array<any>;
	controls: Controls[] = [];
	controlProcessingCols: Array<any>;
	senders: SenderDTO[] = [];
	senderCols: any[];
	senderTitle: string = "Senders";

	tagSystem: TagSystem[] = [];
	tagSystemTitle: string = "Tag System";
	tagSystemCols: any[];
	tagSystems: string[];

	tags: Tags[];
	processFlows: ProcessFlow[];
	tagsTitle: string = "Tag Plate";
	processFlowTitle: string = "Process Flow";
	tagCols: any[];
	processFlowCols: any[];
	mapOfTags = new Map();
	tagPlates: string[];
	workFlows: string[];
	workFlowsNGS: string[];

	flowCell: FlowCell[] = [];
	flowCellTitle: string = "Flow Cells";
	flowCellCols: any[];

	analysis: Analysis[] = [];
	analysisTitle: string = "Analysis";
	analysisCols: any[];

	projects: Project[] = [];
	projectTitle = "Project";
	projectCols: any[];
	projectWorkflows: Project[] = [];
	projectWorkflowTitle = "Project Workflows";
	projectWorkflowCols: any[];

	selectedOption: string = null;
	dropdownOptions: any[] = [
		{ label: 'Business Areas', value: 'Business Areas' },
		{ label: 'Labs', value: 'Labs' },
		{ label: 'Project', value: 'Project' },
		{ label: this.projectWorkflowTitle, value: this.projectWorkflowTitle },
		{ label: 'Machine Types', value: 'Machine Types' },
		{ label: 'Machines', value: 'Machines' },
		{ label: 'Printers', value: 'Printers' },
		{ label: 'Barcode Templates', value: 'Barcode Templates' },
		{ label: 'MA Senders', value: 'MA Senders' },
		{ label: 'Kits', value: 'Kits' },
		{ label: 'Machine Manufacturer', value: 'Machine Manufacturer' },
		{ label: 'Redo Reason', value: 'Redo Reason' },
		{ label: 'Inbound File Processing', value: 'Inbound File Processing' },
		{ label: 'Work Flow', value: 'Work Flow' },
		{ label: 'Control', value: 'Control' },
		{ label: 'Chemical', value: 'Chemical' },
		{ label: 'Senders', value: 'Senders' },
		{ label: 'Tag System', value: 'Tag System' },
		{ label: 'Tag Plates', value: 'Tag Plates' },
		{ label: 'Flow Cells', value: 'Flow Cells' },
		{ label: 'Analysis', value: 'Analysis' },
		{ label: 'Products', value: 'Products' },
		{ label: 'Work Flow NGS', value: 'Work Flow NGS' },
		{ label: 'Sales Item Types', value: 'Sales Item Types' },
		{ label: this.processFlowTitle, value: this.processFlowTitle }
	];


	selectedProcess: string = "";
	constructor(private readonly _masterDataService: MasterDataService, private readonly _messageService: MessagesService,
		private readonly _labEmitterService: LabEmitterService) { }

	ngOnInit() {

		this._labEmitterService.change.subscribe(lab => {
			this.selectedLab = lab;
			console.log("Seleted lab in masterData(e): " + this.selectedLab.label)
		});
		this.selectedLab = JSON.parse(localStorage.getItem('lab'));
		this.selectedProcess = localStorage.getItem('process');

		//Used for displaying the lab values in the crud table
		this.labCols = [
			{ field: 'name', header: 'Lab Name' },
			{ field: 'mix2SeqLabId', header: 'Mix2Seq Lab ID' },
			{ field: 'productionLab', header: 'One-IT Lab ID (BMS compatible)' },
			{ field: 'businessArea', header: 'BusinessArea', sort: 'businessArea.name' },
			{ field: 'countryName', header: 'Country' },
			{ field: 'city', header: 'City' },
			{ field: 'manager', header: 'Lab Manager' },
			{ field: 'defaultLanguage', header: 'Default Language' },
			{ field: 'plateIDRegex', header: 'Plate ID Regex Format' },
			{ field: 'beadchipIDRegex', header: 'Beadchip ID Regex Format' },
			{ field: 'poolIDRegex', header: 'Pool ID Regex Format', display: 'none' },
			{ field: 'array', header: 'Array' },
			{ field: 'ngs', header: 'NGS' },
			{ field: 'active', header: 'Active' },
			{ field: 'dateRange', header: 'Date Range' }
		];
		//Used for displaying manufacturer config values
		this.manufacturerConfigCols = [
			{ field: 'manufacturerName', header: 'Name' },
			{ field: 'machineType', header: 'Machine Type' },
			{ field: 'active', header: 'Active' }
		];
		//Used for displaying the machine values in the crud table
		this.machineCols = [
			{ field: 'name', header: 'Name' },
			{ field: 'barcode', header: 'Barcode' },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'type', header: 'Machine Type', sort: 'type.name', onChangeEvent: true },
			{ field: 'manufacturer', header: 'Manufacturer' },
			{ field: 'hostAddress', header: 'Host Address', width: '20%' },
			{ field: 'subType', header: 'Sub Type' },
			{ field: 'fileType', header: 'File Type' },
			{ field: 'ioCapacity', header: 'In/Out Capacity' },
			{ field: 'active', header: 'Active', width: '5%' }
		];
		//Used for displaying the printer values in the crud table
		this.printerCols = [
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'name', header: 'Name' },
			{ field: 'hostAddress', header: 'Host Address' },
			{ field: 'port', header: 'Port' },
			{ field: 'printEnabled', header: 'Print Enabled' },
			{ field: 'defaultPrinter', header: 'Default Printer' },
			{ field: 'active', header: 'Active' },
			{ field: 'template', header: 'Default Template' }
		];
		//Used for displaying the status values in the crud table
		this.statusCols = [
			{ field: 'name', header: 'Name' },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'machineType', header: 'Machine Type' },
			{ field: 'printer', header: 'Printer' },
			{ field: 'defaultTemplate', header: 'Default Template' },
			{ field: 'nextStep', header: 'Next Step' },
			{ field: 'processList', header: 'Process List Active' },
			{ field: 'platePrefixes', header: 'Plate Prefixes' },
			{ field: 'extraField1', header: 'Extra Field1' },
			{ field: 'inputCheck1', header: 'input Check1' },
			{ field: 'extraField2', header: 'Extra Field2' },
			{ field: 'inputCheck2', header: 'input Check2' },
			{ field: 'active', header: 'Active' }
		];
		//Used for displaying the ba values in the crud table
		this.baCols = [
			{ field: 'name', header: 'Business Area' },
			{ field: 'active', header: 'Active' },
		];

		//Used for displaying the machine Type values in the crud table
		this.machineTypesCols = [
			{ field: 'name', header: 'Name' },
			{ field: 'description', header: 'Description' },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'reception', header: 'Reception' },
			{ field: 'liquidHandling', header: 'Liquid Handling' },
			{ field: 'measurements', header: 'Measurements' },
			{ field: 'scanner', header: 'Scanner' },
			{ field: 'sequencer', header: 'Sequencer' },
			{ field: 'qPcr', header: 'qPCR' },
			{ field: 'qubit', header: 'Qubit' },
			{ field: 'active', header: 'Active' },
		];
		this.healthCols = [
			{ field: 'name', header: 'Service' },
			{ field: 'healthcheckresult', header: 'Status' }
		];

		this.hazardousTypeOptions = [
			{ label: 'Acute Toxicity', hazardousType: HazardousType.ACUTE_TOXICITY },
			{ label: 'Aspiration Hazard', hazardousType: HazardousType.ASPIRATION_HAZARD },
			{ label: 'Compressed Gases', hazardousType: HazardousType.COMPRESSED_GASES },
			{ label: 'Corrosive', hazardousType: HazardousType.CORROSIVE },
			{ label: 'Explosives', hazardousType: HazardousType.EXPLOSIVES },
			{ label: 'Flamable Liquids', hazardousType: HazardousType.FLAMMABLE_LIQUIDS },
			// { label: 'Hazardous To Aquatic Environment', hazardousType: HazardousType.HAZARDOUS_TO_THE_AQUATIC_ENVIRONMENT },
			{ label: 'Oxidising Liquids', hazardousType: HazardousType.OXIDISING_LIQUIDS },
			{ label: 'Toxic Irration', hazardousType: HazardousType.TOXIC_IRRATION },
		];

		this.assayTypeOptions = [
			{ label: 'HS Large Fragment', assayType: AssayType.HS_LARGE_FRAGMENT },
			{ label: 'HS NGS Fragment', assayType: AssayType.HS_NGS_FRAGMENT },
			{ label: 'SS NGS Fragment', assayType: AssayType.SS_NGS_FRAGMENT },
			{ label: 'No Assay Type', assayType: AssayType.NO_ASSAY_TYPE }
		];

		//used to display the access log values
		this.accessLogsCols = [
			{ field: 'puid', header: 'PUID' },
			{ field: 'loginTime', header: 'Login Time' },
			{ field: 'logoutTime', header: 'Logout Time' }
		];

		this.sitConfigCols = [
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'sitKey', header: 'Sales Item Type' },
			{ field: 'bmsKitProductName', header: 'BMS Kit Product Name', sort: 'bmsKitProductName.name' },
			{ field: 'bmsTubeProductName', header: 'BMS Tube Product Name', sort: 'bmsKitProductName.name' },
			{ field: 'jobTime', header: 'Job Time' },
			{ field: 'maxRedo', header: 'Max Redo' }
		];

		this.standardPrimerCols = [
			{ field: 'primerName', header: 'Primer Name' },
			{ field: 'sequence', header: 'Sequence' },
			{ field: 'primerID', header: 'Primer ID' },
			{ field: 'representationColour', header: 'Colour' },
			{ field: 'tm', header: 'Tm °C' },
			{ field: 'gc', header: 'GC %' },
			{ field: 'qcPrimer', header: 'QC Primer' },
			{ field: 'active', header: 'Active' }
		];

		this.templateCols = [
			{ field: 'templateName', header: 'Template Name' },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'entity', header: 'Entity' },
			{ field: 'width', header: 'Width' },
			{ field: 'height', header: 'Height' },
			{ field: 'regex', header: 'Regex' },
			{ field: 'receptionRegex', header: 'reception regex' },
			{ field: 'printPage', header: 'Print Page' },
			{ field: 'batchRegex', header: 'Is Batch' },
			{ field: 'lastPrintedValue', header: 'Last Printed Value' },
			{ field: 'active', header: 'Active' },
		];


		this.masenderCols = [
			{ field: 'senderName', header: 'Sender Name', width: '10%' },
			{ field: 'senderShortName', header: 'Short Name' },
			{ field: 'senderGroupName', header: 'Sender Group Name ' },
			{ field: 'lab', header: 'Lab' },
			{ field: 'mergeGroup', header: 'Merge Group' },
			{ field: 'barcodeValidationRequired', header: 'DB Exist. Check Req?', width: '4%' },
			{ field: 'dataFormat', header: 'Result Report Format' },
			{ field: 'contactID', header: 'Contact ID' },
			{ field: 'defaultPriority', header: 'Default Priority', width: '4%', display: 'none' },
			{ field: 'allowedPCRKits', header: 'Allowed PCR Kits', display: 'none' },
			{ field: 'allowedExtractionKits', header: 'Allowed Extractor Kits', display: 'none' },
			{ field: 'allowedCyclerTypes', header: 'Allowed Cycler Types', display: 'none' },
			{ field: 'allowedExtractorTypes', header: 'Allowed Extractor Types', display: 'none' },
			{ field: 'active', header: 'Active', width: '4%' },
			{ field: 'immediateNCReporting', header: 'Immediate NC Reporting' },
			{ field: 'etwsCustomer', header: 'ETWS Customer' },
			{ field: 'manualReceivedDate', header: 'Manual Received Date', width: '4%' }
		]
		this.masenderDetailCols = [
			{ field: 'senderName', header: 'Sender Name', width: '10%' },
			{ field: 'senderShortName', header: 'Short Name' },
			{ field: 'senderGroupName', header: 'Sender Group Name ' },
			{ field: 'lab', header: 'Lab' },
			{ field: 'barcodeFormat', header: 'Barcode Format' },
			{ field: 'plateIdFormat', header: 'PlateID Format' },
			{ field: 'mergeGroup', header: 'Merge Group' },
			{ field: 'barcodeValidationRequired', header: 'DB Exist. Check Req?', width: '4%' },
			{ field: 'dataFormat', header: 'Result Report Format' },
			{ field: 'contactID', header: 'Contact ID' },
			{ field: 'defaultPriority', header: 'Default Priority', width: '4%', display: 'none' },
			{ field: 'allowedPCRKits', header: 'Allowed PCR Kits', display: 'none' },
			{ field: 'allowedExtractionKits', header: 'Allowed Extractor Kits', display: 'none' },
			{ field: 'allowedCyclerTypes', header: 'Allowed Cycler Types', display: 'none' },
			{ field: 'allowedExtractorTypes', header: 'Allowed Extractor Types', display: 'none' },
			{ field: 'active', header: 'Active', width: '4%' },
			{ field: 'immediateNCReporting', header: 'Immediate NC Reporting' },
			{ field: 'etwsCustomer', header: 'ETWS Customer' },
			{ field: 'ncRetest', header: 'NC Retest' },
			{ field: 'manualReceivedDate', header: 'Manual Received Date', width: '4%' }

		]

		this.kitCols = [
			{ field: 'kitName', header: 'Kit Name' },
			{ field: 'lab', header: 'Lab' },
			{ field: 'kitType', header: 'Kit Type' },
			{ field: 'channel1Gene', header: 'Channel 1-Gene' },
			{ field: 'channel2Gene', header: 'Channel 2-Gene' },
			{ field: 'channel3Gene', header: 'Channel 3-Gene' },
			{ field: 'channel4Gene', header: 'Channel 4-Gene' },
			{ field: 'channel5Gene', header: 'Channel 5-Gene' },
			{ field: 'machineType', header: 'Machine Type' },
			{ field: 'active', header: 'Active' }
		]

		this.kitDetailCols = [
			{ field: 'kitName', header: 'Kit Name' },
			{ field: 'lab', header: 'Lab' },
			{ field: 'kitType', header: 'Kit Type' },
			{ field: 'requiredMaterials', header: 'Required Materials Extraction/Precycling' },
			{ field: 'requiredMaterialsExt', header: 'Required Materials Lysis' },
			{ field: 'kitResults', header: 'Kit Results' },
			{ field: 'swabRestriction', header: 'Swab Restriction' },
			{ field: 'redoReason', header: 'Redo Reasons' },
			{ field: 'channel1Gene', header: 'Channel 1-Gene' },
			{ field: 'channel1File', header: 'Channel 1-File' },
			{ field: 'channel1Dye', header: 'Channel 1-Dye' },
			{ field: 'channel2Gene', header: 'Channel 2-Gene' },
			{ field: 'channel2File', header: 'Channel 2-File' },
			{ field: 'channel2Dye', header: 'Channel 2-Dye' },
			{ field: 'channel3Gene', header: 'Channel 3-Gene' },
			{ field: 'channel3File', header: 'Channel 3-File' },
			{ field: 'channel3Dye', header: 'Channel 3-Dye' },
			{ field: 'channel4Gene', header: 'Channel 4-Gene' },
			{ field: 'channel4File', header: 'Channel 4-File' },
			{ field: 'channel4Dye', header: 'Channel 4-Dye' },
			{ field: 'channel5Gene', header: 'Channel 5-Gene' },
			{ field: 'channel5File', header: 'Channel 5-File' },
			{ field: 'channel5Dye', header: 'Channel 5-Dye' },
			{ field: 'runProtocol', header: 'Run Protocol (BioRad) / Experiment Setup (AriaDX)' },
			{ field: 'thermalProfile', header: 'Thermal Profile (AriaDX)' },
			{ field: 'dominantChannel', header: 'Dominant Channel' },
			{ field: 'machineType', header: 'Machine Type' },
			{ field: 'kitImage', header: 'Kit Image' },
			{ field: 'kitImageName', header: 'Selected Kit Image' },
			{ field: 'processingTime', header: 'Processing Time' },
			{ filed: 'pureAnalysis', header: 'Pure Analysis' },
			{ field: 'active', header: 'Active' }
		]

		//values to be displayed in Max redo dropdown in crud table component
		this.maxRedoValues = [
			{ label: '0', value: 0 },
			{ label: '1', value: 1 },
			{ label: '2', value: 2 },
			{ label: '3', value: 3 },
		];

		this.reactionOptionValues = [
			{ label: 'Standard', value: 'Standard' },
			{ label: 'GCRich', value: 'GCRich' },
			{ label: 'BisulfitSample', value: 'BisulfitSample' }
		]

		this.redoReasonCols = [
			{ field: 'reasonName', header: 'Reason Name', showInGrid: true },
			{ field: 'reasonInfo', header: 'Reason Info', showInGrid: false },
			{ field: 'reasonCode', header: 'Reason Code', showInGrid: true },
			{ field: 'lab', header: 'Lab', showInGrid: true },
			{ field: 'askForChannel', header: 'Ask For Channel', showInGrid: true },
			{ field: 'defaultRedoStep', header: 'Default Redo Step', showInGrid: true },
			{ field: 'receptionIssue', header: 'Reception Issue', showInGrid: true },
			{ field: 'active', header: 'Active', showInGrid: true }
		];

		this.inboundFileProcessingCols = [
			{ field: 'name', header: 'Name', showInGrid: true },
			{ field: 'lab', header: 'Lab', showInGrid: true },
			{ field: 'handler', header: 'Handler', showInGrid: true },
			{ field: 'success', header: 'Successfull', showInGrid: true },
			{ field: 'unsuccess', header: 'Unsuccessfull', showInGrid: true },
			{ field: 'allowedStatus', header: 'Allowed Status', showInGrid: true },
			{ field: 'location', header: 'Location', showInGrid: true },
			{ field: 'active', header: 'Active', showInGrid: true }
		];

		this.workFlowCols = [
			{ field: 'workFlowName', header: 'WorkFlow Name', showInGrid: true },
			{ field: 'lab', header: 'Lab', showInGrid: true },
			{ field: 'workFlowGroup', header: 'Workflow Group', showInGrid: true },
			{ field: 'chipSize', header: 'Chip Size', showInGrid: true },
			{ field: 'chipLayout', header: 'Chip Layout', showInGrid: true },
			{ field: 'controlSchema', header: 'Control Schema', showInGrid: true },
			{ field: 'processFlow', header: this.processFlowTitle, showInGrid: true },
			{ field: 'properties', header: 'Properties', showInGrid: true },
			{ field: 'process', header: 'Process', showInGrid: true },
			{ field: 'prelabelledPlates', header: 'Prelabelled Plates', showInGrid: true },
			{ field: 'sampleTypeInFile', header: 'Sample Type In File', showInGrid: true },
			{ field: 'arrayPartNumber', header: 'Array Part Nr.', showInGrid: true },
			{ field: 'maxArrayIDSize', header: 'Max size for Array ID', showInGrid: false },
			{ field: 'active', header: 'Active', showInGrid: true },
			{ field: 'proxyWeatherbyAPI', header: 'Use Proxy in ProcessUpdate API (Testing)', showInGrid: false }
		];

		this.workFlowNGSCols = [
			{ field: 'workFlowName', header: 'Workflow Name' },
			{ field: 'workFlowGroup', header: 'Workflow Group' },
			{ field: 'processScale', header: 'Process Scale' },
			{ field: 'mergeInStatus', header: 'Merge in Status' },
			{ field: 'statusAfterMerge', header: 'Status after merge' },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'processFlow', header: this.processFlowTitle },
			{ field: 'process', header: 'Process' },
			{ field: 'prelabelledPlates', header: 'Prelabelled Plates' },
			{ field: 'active', header: 'Active' }
		];

		this.controlProcessingCols = [
			{ field: 'controlConfigurationName', header: 'Control Configuration Name', showInGrid: true },
			{ field: 'lab', header: 'Lab', showInGrid: false },
			{ field: 'active', header: 'Active', showInGrid: true }
		];

		this.chemicalCols = [
			{ field: 'chemicalName', header: 'Chemical Name', showInGrid: true },
			{ field: 'lab', header: 'Lab', showInGrid: true },
			{ field: 'workFlow', header: 'Work Flow', showInGrid: true },
			{ field: 'processStep', header: 'Process Step', showInGrid: true },
			{ field: 'description', header: 'Description', showInGrid: true },
			{ field: 'active', header: 'Active', showInGrid: true }
		];

		this.senderCols = [
			{ field: 'senderName', header: 'Sender Name', width: '10%' },
			{ field: 'senderShortName', header: 'Short Name' },
			{ field: 'senderGroupName', header: 'Sender Group Name ' },
			{ field: 'lab', header: 'Lab' },
			{ field: 'barcodeFormat', header: 'Barcode Format' },
			{ field: 'trfBarcode', header: 'TRF Barcode' },
			{ field: 'trfFormat', header: 'TRF Format' },
			{ field: 'boxBarcode', header: 'Box Barcode' },
			{ field: 'boxBarcodeFormat', header: 'Box Barcode Format' },
			{ field: 'externalSampleBarcode', header: 'Scan Ext Sample Barcode' },
			{ field: 'regionalCodes', header: 'External Sample Format' },
			{ field: 'checkForIdentity', header: 'Check For Identity' },
			{ field: 'mergeGroup', header: 'Merge Group' },
			{ field: 'barcodeValidationRequired', header: 'DB Exist. Check Req?', width: '4%' },
			{ field: 'dataFormat', header: 'Data Format' },
			{ field: 'contactID', header: 'Contact ID' },
			{ field: 'barcodeExistOnBag', header: 'Is Bar code On Bag', width: '3%' },
			{ field: 'swabType', header: 'Swab Type', width: '4%' },
			{ field: 'storageTime', header: 'Storage Time For NC Samples (days)' },
			{ field: 'defaultPriority', header: 'Default Priority', width: '4%', display: 'none' },
			{ field: 'allowedPCRKits', header: 'Allowed PCR Kits', display: 'none' },
			{ field: 'allowedExtractionKits', header: 'Allowed Extractor Kits', display: 'none' },
			{ field: 'allowedCyclerTypes', header: 'Allowed Cycler Types', display: 'none' },
			{ field: 'allowedExtractorTypes', header: 'Allowed Extractor Types', display: 'none' },
			{ field: 'active', header: 'Active', width: '4%' },
			{ field: 'categoryType', header: 'Problem Category', display: 'none' }
		]

		this.tagSystemCols = [
			{ field: 'tagSystemName', header: 'Tag System Name', sort: 'tagSystemName' },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'active', header: 'Active' }
		];

		this.tagCols = [
			{ field: 'tagPlateName', header: 'Tag Plate Name' },
			{ field: 'lab', header: 'Lab', display: 'none' },
			{ field: 'tagSystem', header: 'Tag System' },
			{ field: 'tagPlateBarcode', header: 'Active Plate Barcodes', display: 'none' },
			{ field: 'runPlanningSequence', header: 'Run Planning Sequence' },
			{ field: 'active', header: 'Active' }
		];

		this.processFlowCols = [
			{ field: 'processFlowName', header: 'ProcessFlowName', group: "common" },
			{ field: 'sampleType', header: 'SampleType', group: "common" },
			{ field: 'beadChipSize', header: 'BeadChipSize', group: "common" },
			{ field: 'lab', header: 'Lab', group: "common" },
			{ field: 'existenceCheck', header: 'ExistenceCheck', group: "Reception", display: 'none' },
			{ field: 'plateReception', header: 'PlateReception', group: "Reception", display: 'none' },
			{ field: 'singleReception', header: 'SingleReception', group: "Reception", display: 'none' },
			{ field: 'manualReception', header: 'ManualReception', group: "Reception", display: 'none' },
			{ field: 'automaticReception', header: 'AutomaticReception', group: "Reception", display: 'none' },
			{ field: 'qcScan', header: 'QC-Scan', group: "Preparation", display: 'none' },
			{ field: 'okTOpureHair', header: 'OkTOpure Hair', group: "Preparation", display: 'none' },
			{ field: 'okTOpureEartag', header: 'OkTOpure Eartag', group: "Preparation", display: 'none' },
			{ field: 'ExEartagTLR', header: 'TLR Eartag', group: "Preparation", display: 'none' },
			{ field: 'qcNanodrop', header: 'QCNanodrop', group: "Preparation", display: 'none' },
			{ field: 'merge96', header: '96 Merge', group: "Preparation", display: 'none' },
			{ field: 'detailedWorkflow', header: 'Detailed Workflow', group: "common" },
			{ field: 'illuminaExInfinium', header: 'Illumina Ex Infinium', group: "SampleFlow", display: 'none' },
			{ field: 'axiom384Propel', header: 'Axiom384 Propel', group: "SampleFlow", display: 'none' },
			{ field: 'manualPreparation', header: 'ManualPreparation', group: "SampleFlow", display: 'none' },
			{ field: 'precell', header: 'Precell', group: "SampleFlow", display: 'none' },
			{ field: 'manualPost', header: 'ManualPost', group: "SampleFlow", display: 'none' },
			{ field: 'resultEvaluation', header: 'Result Evaluation', group: "SampleFlow", display: 'none' },
			{ field: 'active', header: 'Active', group: "common" }
		];

		this.flowCellCols = [
			{ field: 'flowCellName', header: "Configuration Name" },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'sequencer', header: "Sequencer" },
			{ field: 'flowCellType', header: "Flow Cell Type" },
			{ field: 'flowCellMode', header: "Flow Cell Mode" },
			{ field: 'physicalLanes', header: "Physical lanes" },
			{ field: 'logicalLanes', header: "Logical lanes" },
			{ field: 'totalCapacity', header: "Total Capacity" },
			{ field: 'laneCapacity', header: "Lane Capacity" },
			{ field: 'capabilities', header: "capabilities", display: 'none' },
			{ field: 'active', header: "Active" }
		];

		this.analysisCols = [
			{ field: 'analysisName', header: "Analysis Name" },
			{ field: 'pipelineName', header: 'Pipeline Name' },
			{ field: 'versionOfAnalysis', header: "Version" },
			{ field: 'sequencer', header: "Sequencer" },
			{ field: 'constraint', header: "constraint", display: 'none' },
			{ field: 'product', header: "Product" },
			{ field: 'productId', header: "Product Id" },
			{ field: 'mismatch', header: "Mismatch" },
			{ field: 'limsUpload', header: "LimsUpload" },
			{ field: 'autoAnalysis', header: "AutoAnalysis" },
			{ field: 'reanalysis', header: "Reanalysis" },
			{ field: 'indexAnalysis', header: "IndexAnalysis" },
			{ field: 'ignoreMissingFiles', header: "IgnoreMissingFiles" },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'active', header: "Active" }
		];
		//Used to displaying the product in crude table
		this.productCols = [
			{ field: 'name', header: 'Product Type' },
			{ field: 'lab', header: 'Lab', sort: 'lab.name' },
			{ field: 'workflow', header: 'Work Flow' },
			{ field: 'snpProfile', header: 'SNP Profile Name' },
			{ field: 'salesItemType', header: 'Sales Item Type' },
			{ field: 'tagSystem', header: 'Tag System' },
			{ field: 'requiredRead', header: 'Required Read' },
			{ field: 'premixed', header: 'Premixed' },
			{ field: 'active', header: 'Active' }
		];

		this.projectCols = [
			{ field: 'projectId', header: 'Project ID' },
			{ field: 'projectName', header: 'Project Name' },
			{ field: 'lab', header: 'Lab' },
			{ field: 'sender', header: 'Sender' },
			{ field: 'identifier', header: 'Identifier(s)' },
			{ field: 'newUI', header: 'New UI' },
			{ field: 'updateWeatherbys', header: 'Update Weatherbys' },
			{ field: 'activationCheck', header: 'Activation Check' },
			{ field: 'active', header: 'Active' },
		]

		this.projectWorkflowCols = [
			{ field: 'workflowName', header: 'Workflow Name' },
			{ field: 'projectId', header: 'Project ID' },
			{ field: 'lab', header: 'Lab' },
			{ field: 'identifiers', header: 'Identifier(s)' },
			{ field: 'receptionType', header: 'Reception Type' },
			{ field: 'automatedReception', header: 'Automated Reception' },
			{ field: 'qcScan', header: 'QC Scan' },
			{ field: 'plateMerge', header: 'Plate Merge' },
			{ field: 'storageTemperature', header: 'Storage Temperature' },
			{ field: 'buffer', header: 'Buffer' },
			{ field: 'tat', header: 'TAT' },
			{ field: 'samplesHaveBarcodes', header: 'Samples Have Barcodes' },
			{ field: 'arrayPartNumber', header: 'Array Part Number' },
			{ field: 'upstream', header: 'Upstream' },
			{ field: 'downstream', header: 'Downstream' },
			{ field: 'aliquotVolume', header: 'Aliquot Volume' },
			{ field: 'active', header: 'Active' },
		]

		//Service methods
		this._masterDataService.getCountries().subscribe(results => {
			if (!results) {
				return;
			}
			this.countries = results.data;
		});

		this._masterDataService.getLabs(false).subscribe({
			next: (results) => {
				if (!results) {
					return;
				}
				this.labs = results.data;
				this.labs.forEach(function (lab) {
					if (lab.mix2SeqLabId == 0) {
						lab.mix2SeqLabId = null;
					}
				})
			},
			error: (error: any) => {
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);

			}
		});

		this._masterDataService.getBusinessAreas(true).subscribe({
			next: (results) => {
				if (!results) {
					return;
				}
				console.log("Active business Areas:", results.data);
				this.baOptions = results.data;
			},
			error: (error: any) => {
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);

			}

		});

		this._masterDataService.getLabs(true).subscribe({
			next: (results) => {
				if (!results) {
					return;
				}
				console.log("Active labs:", results.data);
				this.labOptions = results.data;
			},
			error: (error: any) => {
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);

			}
		});

		this._masterDataService.getConfigList(this.selectedLab.lab._id, "machineType", 0, 100, true).subscribe(
			results => {
				if (!results) {
					return;
				}
				console.log("Active machine types:", results.data);
				this.machineTypesOptions = results.data;
			},
			error => {
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);

			}
		);

		this._masterDataService.getPrinters(true).subscribe({
			next: (results) => {
				if (!results) {
					return;
				}
				console.log("Active printers:", results.data);
				this.printerOptions = results.data;
			},
			error: (error: any) => {
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);

			}
		});

		this._masterDataService.getConfigList(this.selectedLab.lab._id, "product", 0, 100, false).subscribe(
			results => {
				if (!results) {
					return;
				}
				console.log("Active Products:", results.data);
				this.products = results.data;
			},
			error => {
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);
			}
		);

		this._masterDataService.getTagsystem(this.selectedLab.lab).subscribe({
			next: (results) => {
				if (!results) {
					return;
				}
				this.tagSystem = results.data.filter(tagSystem => tagSystem.active == true);
				this.loading = false;
				console.log("Active Tag Systems:", this.tagSystem)
			},
			error: (error: any) => {
				this.tagSystem = [];
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);
			}
		});

		this._masterDataService.getConfigList(this.selectedLab.lab._id, "workflowngs", 0, 100).subscribe(
			results => {
				if (!results) {
					return;
				}
				this.workFlowNGS = results.data;
			},
			error => {
				this.workFlowNGS = [];
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);
			}
		);

		this._masterDataService.getConfigList(this.selectedLab.lab._id, "salesItemType", 0, 100).subscribe(
			results => {
				if (!results) {
					return;
				}
				console.log("Sales item type configuration --> :", results.data);
				this.sitConfigs = results.data;
			},
			error => {
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);
			}
		);

	}

	setColor(status) {
		if (status == 200) {
			return "up"
		} else if (status == 503) {
			return "down"
		} else {
			return null
		}
	}

	filterRecords(records: any[]): any[] {
		if (!records || records.length < 1) return;
		if (this.selectedProcess === 'NGS') {
			records = records.filter(rec => rec.process == 'NGS');
		} else {
			records = records.filter(rec => rec.process != 'NGS');
		}
		return records;
	}

	onDropdownChange(event: any) {
		switch (event.value) {
			case "Business Areas":
				{
					this._masterDataService.getBusinessAreas(false).subscribe({
						next: (results) => {
							if (!results) {
								return;
							}
							console.log("business Areas:", results.data);
							this.businessAreas = results.data;
						},
						error: (error: any) => {
							const message = this.errorHandler.handleError(error);
							this._messageService.addErrorMessage(message);
						}
					});
					break;
				}
			case "Labs": {
				if (this.selectedLab && this.selectedLab.lab.businessArea.name == "Applied Genomics") {
					this._masterDataService.getLabsBasedOnSelectedLabForAppliedGenomics(this.selectedLab.lab).subscribe({
						next: (results) => {
							if (!results) {
								return;
							}
							console.log("labs:", results.data);
							this.labs = results.data;
							this.labs.forEach(function (lab) {
								if (lab.mix2SeqLabId == 0) {
									lab.mix2SeqLabId = null;
								}
							})
						},
						error: (error: any) => {
							const message = this.errorHandler.handleError(error);
							this._messageService.addErrorMessage(message);

						}
					});

				} else {
					this._masterDataService.getLabs(false).subscribe({
						next: (results) => {
							if (!results) {
								return;
							}
							console.log("labs:", results.data);
							this.labs = results.data;
							this.labs.forEach(function (lab) {
								if (lab.mix2SeqLabId == 0) {
									lab.mix2SeqLabId = null;
								}
							})
						},
						error: (error: any) => {
							const message = this.errorHandler.handleError(error);
							this._messageService.addErrorMessage(message);

						}
					});
				}

				break;
			}
			case "Machine Types": {
				this.fetchAndSetMasterdataValues("machineType", "machineTypes");
				break;
			}
			case "Machines": {
				this.fetchAndSetMasterdataValues("machine", "machines");
				break;
			}
			case "Printers": {
				this._masterDataService.getPrinters(false).subscribe({
					next: (results) => {
						if (!results) {
							return;
						}
						console.log("Printers:", results.data);
						this.printers = results.data;
					},
					error: (error: any) => {
						const message = this.errorHandler.handleError(error);
						this._messageService.addErrorMessage(message);

					}
				});
				break;
			}
			case "Barcode Templates": {
				this._masterDataService.getTemplates().subscribe({
					next: (results) => {
						if (!results) {
							return;
						}
						console.log("Templates :", results.data);
						this.templates = results.data;
					},
					error: (error: any) => {
						const message = this.errorHandler.handleError(error);
						this._messageService.addErrorMessage(message);
					}
				});
				break;
			}
			case "MA Senders": {
				this.fetchAndSetMasterdataValues("masender", "masenders");
				break;
			}
			case "Kits": {
				this.fetchAndSetMasterdataValues("kits", "kits");
				break;
			}
			case "Machine Manufacturer": {
				this.fetchAndSetMasterdataValues("machineManufacturer", "manufacturersList");
				break;
			}
			case "Redo Reason": {
				this.fetchAndSetMasterdataValues("redoReasons", "redoReasons");
				break;
			}
			case "Inbound File Processing": {
				this.fetchAndSetMasterdataValues("inboundFileProcessing", "inboundFileProcessing");
				break;
			}
			case "Work Flow": {
				this.fetchAndSetMasterdataValues("workflow", "workFlow");
				break;
			}
			case "Control": {
				this.fetchAndSetMasterdataValues("controls", "controls");
				break;
			}
			case "Chemical": {
				this.fetchAndSetMasterdataValues("chemical", "chemical");
				this.chemical = this.filterRecords(this.chemical);
				break;
			}
			case "Senders": {
				this.fetchAndSetMasterdataValues("sender", "senders");
				break;
			}
			case "Tag System": {
				this.loading = true;
				this.tagSystem = []
				this._masterDataService.getTagsystem(this.selectedLab.lab).subscribe({
					next: (results) => {
						if (!results) {
							return;
						}
						this.tagSystem = results.data;
						this.loading = false;
						console.log("Active Tag Systems:", this.tagSystem)
					},
					error: (error: any) => {
						this.tagSystem = [];
						const message = this.errorHandler.handleError(error);
						this._messageService.addErrorMessage(message);
					}
				});
				break;
			}
			case "Tag Plates": {
				this.loading = true
				this.tags = [];
				this._masterDataService.getTags(this.selectedLab.lab).subscribe({
					next: (results) => {
						if (!results) {
							return;
						}
						this.tags = results.data;
						console.log("Active Tags:", this.tags);
						this.loading = false
					},
					error: (error: any) => {
						const message = this.errorHandler.handleError(error);
						this._messageService.addErrorMessage(message);
					}
				});
				this._masterDataService.getMapOfTags(this.selectedLab.lab._id, null).subscribe({
					next: (results) => {
						if (!results) {
							return;
						}
						this.mapOfTags = new Map(Object.entries(results.data));
						this.tagPlates = Array.from(this.mapOfTags.keys())
						this.loading = false
					},
					error: (error: any) => {
						const message = this.errorHandler.handleError(error);
						this._messageService.addErrorMessage(message);
					}
				});
				break;
			}
			case "Flow Cells": {
				this.fetchAndSetMasterdataValues("flowCell", "flowCell");
				break;
			}
			case "Analysis": {
				this.fetchAndSetMasterdataValues("analysis", "analysis");
				break;
			}
			case "Work Flow NGS": {
				this.fetchAndSetMasterdataValues("workflowngs", "workFlowNGS");
				break;
			}
			case "Sales Item Types": {
				this.fetchAndSetMasterdataValues("salesItemType", "sitConfigs");
				break;
			}
			case this.processFlowTitle: {
				this.fetchAndSetMasterdataValues("processFlow", "processFlows");
				break;
			}
			case "Project": {
				this.fetchAndSetMasterdataValues("project", "projects");
				break;
			}
			case this.projectWorkflowTitle: {
				this.fetchAndSetMasterdataValues("projectWorkflow", "projectWorkflows");
				break;
			}
		}
	}

	private fetchAndSetMasterdataValues(configName: string, variableName: string) {
		this.loading = true;
		this._masterDataService.getConfigList(this.selectedLab.lab._id, configName, 0, 200).subscribe({
			next: results => {
				this.loading = false;
				if (!results) {
					return;
				}
				console.log(`${configName} --> :`, results.data);
				this[variableName] = results.data;
			},
			error: error => {
				this.loading = false;
				this[variableName] = [];
				const message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);
			}
		});
	}

}
